import { Button } from '@/components/ui/atoms/button'
import { SUBSCRIPTION } from '@/consts'
import { cn } from '@/lib/client'
import { ArrowUpRight } from 'lucide-react'

export default function SubscriptionBanner({
  className,
}: {
  className?: string
}) {
  return (
    <div className={cn('my-8', className)}>
      <div className="relative isolate overflow-hidden bg-zinc-900 py-12 px-8 rounded-xl">
        <div className="flex flex-col text-center lg:flex-row lg:text-left lg:items-center">
          <div className="">
            <h3 className="text-2xl font-bold tracking-tight text-white sm:text-3xl">
              Tenha acesso completo a todo o conteúdo do Direção Concursos
            </h3>
            <p className="mt-4 text-md leading-6 text-zinc-300">
              Acesse todas as aulas e cursos do site em um único lugar
            </p>
          </div>
          <div className="mt-6 lg:mt-0 lg:ml-12 lg:items-center">
            <Button variant={'default'} asChild className="w-full lg:w-[180px]">
              <a
                href={SUBSCRIPTION}
                target="_blank"
                aria-label="Assinaturas"
                rel="noreferrer"
              >
                Saiba mais
                <ArrowUpRight className="ml-1 h-4 w-4" />
              </a>
            </Button>
          </div>
        </div>
        <div
          className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-35rem)]"
          aria-hidden="true"
        >
          <div
            className="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#80d7ff] to-[#9089fc] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]"
            style={{
              clipPath:
                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
            }}
          />
        </div>
      </div>
    </div>
  )
}
